var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import icons from './constants/Icons';

var FontIcon = function (_React$PureComponent) {
  _inherits(FontIcon, _React$PureComponent);

  function FontIcon() {
    _classCallCheck(this, FontIcon);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  FontIcon.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        className = _props.className,
        icon = _props.icon,
        other = _objectWithoutProperties(_props, ['className', 'icon']);

    var fontClass = classNames('epsicon', className, (_classNames = {}, _classNames['epsicon-' + icon] = icon, _classNames));

    return React.createElement('i', _extends({ className: fontClass }, other));
  };

  return FontIcon;
}(React.PureComponent);

export { FontIcon as default };
FontIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  icon: PropTypes.oneOf(icons).isRequired
} : {};